// http://vuex.vuejs.org/en/getters.html
import { isEmpty } from 'lodash'

// if has token, we assume that user is logged in our system
export const isLogged = ({ token }) => !isEmpty(token)
// get current user data
export const currentUser = ({ user }) => {

            if(!user || !user.displayName ) {
              try {
                var user = JSON.parse(localStorage.getItem('login'));
              } catch (e) {
                return null;
              }
            }
            return user;
}

export const LoginedUser = ({ logineduser }) => {
            
  if(!logineduser) {
    var logineduser = JSON.parse(localStorage.getItem('user')||null);
  }
  return logineduser;


}






// WEBPACK FOOTER //
// ./src/app/auth/vuex/getters.js